/**
 * ThemeToggle: cycles System -> Light -> Dark. The accessible name says what a press does next
 * ("Theme: system. Switch to light theme"), not the current state alone.
 *
 *   <ThemeToggle variant="header" />
 */
import { useTheme } from "@/context/ThemeContext";
import IconButton from "./IconButton";

const OPTIONS = {
  system: { label: "system", icon: "lucide:monitor", next: "light" },
  light: { label: "light", icon: "lucide:sun", next: "dark" },
  dark: { label: "dark", icon: "lucide:moon", next: "system" },
} as const;

export default function ThemeToggle({ variant = "sidebar" }: { variant?: "sidebar" | "header" }) {
  const { theme, setTheme } = useTheme();
  if (variant !== "header") return null;

  const current = OPTIONS[(theme as keyof typeof OPTIONS) ?? "system"] ?? OPTIONS.system;
  const nextLabel = current.next === "system" ? "system theme" : `${current.next} theme`;

  return (
    <IconButton
      icon={current.icon}
      label={`Theme: ${current.label}. Switch to ${nextLabel}`}
      size="md"
      onClick={() => setTheme(current.next)}
    />
  );
}
